module.exports = __webpack_public_path__ + "static/egyptian-cotton-duvet-cover-white-1-6464a7cc17479e5901ba6b423d2ea2fc.png";